<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    Edit Reminder Frequency
  </li>
</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
            <strong>Edit Reminder Frequency</strong>    
    </span>
    <button type="button" class="btn btn-sm btn-default pull-right btn-back"  (click)="ShowCompanyTasks()">
        <i class="fa fa-chevron-circle-left"></i>Back
    </button>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <!-- <div class="modal-body"> -->
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
                id="companytaskTable" style="cursor: pointer;width:100%">
                <thead>
                  <tr>
                    <th style="display: none"></th>
                    <th style="width:5%">
                      <div class="md-checkbox">
                        <input id="selectcheckboxall" type="checkbox" [(ngModel)]="selectedAll" (change)="selectAll();" />
                        <label for="selectcheckboxall">&nbsp;</label>
                      </div>
                    </th>
                    <th style="width:30%" class="editableRow">Task Name</th>
                    <th style="width:5%" class="wrappable">Reminder Start (in days)</th>
                    <th style="width:5%" class="wrappable">Reminder Frequency (days)</th>
                    <th style="width:5%" class="wrappable">1st Escalation Start</th>
                    <th style="width:5%" class="wrappable">2nd Escalation Start</th>
                    <th style="width:5%" class="wrappable">1st Escalation reminder frequency</th>
                    <th style="width:5%" class="wrappable">2nd Escalation reminder frequency</th>
                    <th style="width:5%" class="wrappable">Due Date(in days)</th>
                    <th style="width:5%" class="wrappable">Trigger Name</th>
                    <th style="width:20%" class="wrappable">Meeting Type</th>


                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let companytask of companytasklist; let count=index">
                      <td tabindex="1" style="display: none">{{companytask._id}}</td>
                    <td>
                      <div class="md-checkbox">
                        <input id="selectcheckbox{{count +1 }}" type="checkbox" [(ngModel)]="companytask.SelectedTask" (change)="checkIfAllSelected();"
                          (change)="checkselected($event);">
                        <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                      </div>
                    </td>

                    <td class="editableRow">{{companytask.TasksData.TaskName }}</td>

                    <td class="wrappable">
                      <span *ngIf="!companytask.SelectedTask">{{companytask.TasksData.ReminderDays}}</span>
                      <input type="number" min="0" max="90" LimittoMaxNumber LimittoMinNumber   *ngIf="companytask.SelectedTask"   [ngClass]="{editableRow: !companytask.SelectedTask}"
                        [(ngModel)]="companytask.TasksData.ReminderDays" class="rowSize" [disabled]="!companytask.SelectedTask"
                      >
                    </td>
                    <td class="wrappable">
                      <span *ngIf="!companytask.SelectedTask">{{companytask.TasksData.ReminderPeriod}}</span>
                      <input *ngIf="companytask.SelectedTask" type="number" min="0" max="30" LimittoMaxNumber LimittoMinNumber  [ngClass]="{editableRow: !companytask.SelectedTask}"
                        [(ngModel)]="companytask.TasksData.ReminderPeriod" class="rowSize" [disabled]="!companytask.SelectedTask"
                        [OnlyNumber]=true>
                    </td>
                    <td class="wrappable">
                      <span *ngIf="!companytask.SelectedTask">{{companytask.TasksData.EscalationDays}}</span>
                      <input *ngIf="companytask.SelectedTask" type="number" min="0" max="30" LimittoMaxNumber LimittoMinNumber [ngClass]="{editableRow: !companytask.SelectedTask}"
                        [(ngModel)]="companytask.TasksData.EscalationDays" class="rowSize" [disabled]="!companytask.SelectedTask"
                        [OnlyNumber]=true> </td>
                    <td class="wrappable">
                      <span *ngIf="!companytask.SelectedTask">{{companytask.TasksData.Level2EscalationDays}}</span>
                      <input *ngIf="companytask.SelectedTask" type="number" min="0" max="30" LimittoMaxNumber LimittoMinNumber [ngClass]="{editableRow: !companytask.SelectedTask}"
                        [(ngModel)]="companytask.TasksData.Level2EscalationDays" class="rowSize" [disabled]="!companytask.SelectedTask"
                        [OnlyNumber]=true></td>
                    <td class="wrappable">
                      <span *ngIf="!companytask.SelectedTask">{{companytask.TasksData.ReminderPeriodLevel1}}</span>
                      <input *ngIf="companytask.SelectedTask" type="number" min="0" max="30" LimittoMaxNumber LimittoMinNumber [ngClass]="{editableRow: !companytask.SelectedTask}"
                        [(ngModel)]="companytask.TasksData.ReminderPeriodLevel1" class="rowSize" [disabled]="!companytask.SelectedTask"
                        [OnlyNumber]=true></td>
                    <td class="wrappable">
                      <span *ngIf="!companytask.SelectedTask">{{companytask.TasksData.ReminderPeriodLevel2}}</span>
                      <input *ngIf="companytask.SelectedTask" type="number" min="0" max="30" LimittoMaxNumber LimittoMinNumber [ngClass]="{editableRow: !companytask.SelectedTask}"
                        [(ngModel)]="companytask.TasksData.ReminderPeriodLevel2" class="rowSize" [disabled]="!companytask.SelectedTask"
                        [OnlyNumber]=true></td>
                    <td class="wrappable">
                      <span *ngIf="!companytask.SelectedTask">{{companytask.TasksData.CompletionDays}}</span>
                      <input *ngIf="companytask.SelectedTask" type="number" min="-9999" max="9999" LimittoMaxNumber [ngClass]="{editableRow: !companytask.SelectedTask}"
                        [(ngModel)]="companytask.TasksData.CompletionDays" class="rowSize" [disabled]="!companytask.SelectedTask"
                        (keydown)="onlyNumber($event)"></td>
                    <td class="wrappable">{{companytask.TasksData.TriggerName}}</td>
                    <td class="wrappable">
                      <span *ngIf="!companytask.SelectedTask">{{companytask.TasksData.MeetingType}}</span>
                      <select *ngIf="companytask.SelectedTask" class="form-control select" [(ngModel)]="companytask.TasksData.MeetingTypeId" [disabled]="!companytask.SelectedTask" style="max-width:80%">  
                        <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}} >  
                          {{meetingType.MeetingType}}  
                        </option> 
                       </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          <!-- </div> -->
          <div class="modal-footer">
            <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="reset()"> <i class="fa fa-refresh"></i>Clear</button>
            <button id="btnupdateTasks" style="float: right" type="button" class="btn btn-sm btn-primary" (click)="updateTasks()" [disabled]="!IsSelectedTasks || disabledOnclick"><i class="fa fa-save"></i>Update</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="resetConfirmation" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true" style="top: 50px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabelForDelete"><i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                   <span aria-hidden="true">×</span>
                </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                Are you sure you want to reset the form data?
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-primary" (click)="resetFormData()"><i class="fa fa-check"></i>Yes</button>
            <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal"><i class="fa fa-times"></i>No</button>
          </div>
        </div>
      </div>
    </div>


</section>
<app-alert></app-alert>